module.exports = __webpack_public_path__ + "static/media/img-download-center2.0cda1201.png";